var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-wrapper",attrs:{"id":"storybook-preview-icons"}},[_c('h1',[_vm._v(_vm._s(_vm.$t('icon')))]),_c('TabMenu',{staticClass:"m-t-20",attrs:{"menus":_vm.menus}}),_c('StorybookTemplate',[_c(_vm.childTag,{tag:"component"})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }